/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: dashboard
 *| (C) Copyright IBM Corp. 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/core-client/js/core-client/utils/BrowserUtils'
], function(BrowserUtils) {

	return class MobileUtil {

		static _isMobileScreenSize() {
			return this.getMediaQueryResults().matches;
		}

		static getMediaQueryResults() {
			return window.matchMedia('only screen and (max-width: 521px), only screen and (max-height: 521px)');
		}

		static areMobileConditionsMet() {
			return BrowserUtils.isMobile() &&
				this._isMobileScreenSize();
		}
	};
});
